<script>
  export let uncalled = 0;
  export let variant = 'house';
  export let compact = false;
</script>

{#if uncalled > 0}
  <div
    class="uncalled-legend"
    class:uncalled-legend--senate={variant === 'senate'}
    aria-hidden="true"
  >
    <span
      class="uncalled-legend__label"
      class:text-base={!compact}
      class:text-sm={compact}
    >
      <span class="uncalled-legend__count">
        <strong>{uncalled}</strong>
        {uncalled === 1 ? 'race' : 'races'}
      </span>
      uncalled
    </span>

    <svg
      class="uncalled-square"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      width="40"
      height="40"
      aria-hidden="true"
    >
      <rect
        x="2"
        y="2"
        width="36"
        height="36"
        fill="none"
        stroke="#777"
        stroke-width="4"
      />
    </svg>
  </div>
{/if}